import { CompanyBuilder, GetCompanyInfoOutput } from '../companies.types';

export const getCompanyInfo = (builder: CompanyBuilder) =>
  builder.query<GetCompanyInfoOutput, void>({
    query: () => ({
      url: '/companies/employer',
      method: 'GET',
    }),
    providesTags: () => ['Company'],
  });
